import {BaseDao} from "./BaseDao";
import {ApiHelper} from "../apiHelper";
import {ConstantMan} from "../constantMan";

export class RedshiftDao extends BaseDao{
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.REDSHIFT, apiHelper);
  }
}